module.exports = __webpack_public_path__ + "static/media/wata_software_logo.0e85bfa4.png";